import React,{useState,useEffect} from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import petsliderimg from "../../assets/images/petslider.png";
import { Link } from "react-router-dom";
import axios from "axios";
import config from "../../config";

const PetSlider = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay:false
  };
  const [kennel, setKennel] = useState([]);
  useEffect(() => {
    const fetchKennels = async () => {
      try {
        const response = await axios.get(
          `${config.API_BASE_URL}/seller/getvendorbanner`
        );
        if (response.data.status==200) {
          setKennel(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching bookings data:", error);
      }
    };

    fetchKennels();
  }, []);

  return (
    <>
        <div className="container mx-auto py-8 md:block hidden">
        <Slider {...settings}>
            {kennel.map((slide, index) => (
              slide.Desc?
            <div key={index}>
                <div
                className="flex flex-row items-center justify-center bg-[#9A83E7] h-[200px] rounded-lg p-0 bg-contain bg-left bg-no-repeat"
                // style={{ backgroundImage: `url(${yellowbg})`, backgroundSize:"36% 100%" }}
                >
                <div className="w-[30%]">
                    <div className=" rounded-[100%]">
                    {slide.image?
                    <img
                        src={slide.image}
                        alt="Dog and Cat"
                        className="w-[160px] h-[160px] rounded-full"
                    />:
                    <img
                        src={petsliderimg}
                        alt="not"
                        className="h-auto w-full rounded-full"
                    />}
                    </div>
                </div>

                <div className="w-[65%]">
                    <h2 className="text-xl font-bold mt-4 text-white">
                    {slide.company_name}
                    </h2>
                    <p className="mt-2 text-white  line-clamp-2 ">
                    {slide.Desc}
                    </p>
                    <Link to={`https://findlocalpetservices.com/kennel-details/?id=${slide.id}`}><button className="my-4 px-6 py-2 bg-[#FF6216] text-white rounded-[10px]">
                    Book Now
                    </button>
                    </Link>
                </div>
                </div>
            </div>:""
            ))}
        </Slider>
        </div>
        <div className="container mx-auto mt-5 md:hidden block rounded-[20px] bg-[#9A83E7] ">
        <Slider {...settings}>
        {kennel.map((slide, index) => (
          slide.Desc?
            <div key={index} className="h-10" >
            <div  className="flex flex-row items-center justify-center  p-4 ">
            <div className="text-left">
            <h2 className="text-[35px] font-[500] mt-4 text-white leading-[3rem]">
                {slide.company_name}
            </h2>
            <p className="text-left mt-2 text-white text-[20px]  line-clamp-2 ">
                {slide.Desc}
            </p>
            <Link to={`https://findlocalpetservices.com/kennel-details/?id=${slide.id}`}><button className="my-4 px-6 py-2 bg-[#FF6216] text-white rounded-[10px]">
                    Book Now
                    </button>
                    </Link>
            </div>
            
            </div>
            <div  className="flex flex-row items-center justify-center bg-[#9A83E7]">
           
            <div
                className="flex flex-row items-center justify-center bg-[#9A83E7]  rounded-lg p-0"
                
            >
                <div className="flex items-center justify-center   bg-contain  bg-no-repeat" 
                // style={{ backgroundImage: `url(${yellowmobilebg})`, backgroundSize:"100%" }}
                >
                <div className="flex items-center justify-center   rounded-[100%]">
                
                {slide.image?
                  <img
                      src={slide.image}
                      alt="Dog and Cat"
                      className="h-[300px] w-[300px] rounded-full "
                  />:
                  <img
                      src={petsliderimg}
                      alt="not"
                      className="h-auto w-full rounded-full"
                  />}
                </div>
                </div>

               
            </div>
            </div>
            </div>:""
        ))}
        </Slider>
        </div>
    </>
  );
};

export default PetSlider;
